import { useCallback, useState } from 'react'

function useDisclosure(initialState) {
  const [value, setState] = useState(initialState)
  const onToggle = useCallback(() => setState(state => !state), [])

  return Object.assign([value, onToggle], { value, onToggle })
}

export default useDisclosure
